var map = {
	"./BestThesis.vue": [
		"1ac8",
		"chunk-3d84a1bb"
	],
	"./ContactUs.vue": [
		"e9bb",
		"chunk-cf2a1630"
	],
	"./Contacts.vue": [
		"c93c",
		"chunk-401a769a"
	],
	"./CookiePolicy.vue": [
		"8368",
		"chunk-2d0ddbf3"
	],
	"./CoursePresentation.vue": [
		"5591",
		"chunk-e67116b8"
	],
	"./Event.vue": [
		"d3dc",
		"chunk-5d34c09e"
	],
	"./ExperimentalFacilities.vue": [
		"056b",
		"chunk-ee201e32"
	],
	"./ExternalScholarships.vue": [
		"90c7",
		"chunk-2d0e4a81"
	],
	"./ForOrganizations.vue": [
		"a194",
		"chunk-5417a6e4"
	],
	"./ForStudents.vue": [
		"bb20",
		"chunk-6eb1ff12"
	],
	"./Home.vue": [
		"bb51",
		"chunk-4f998fbc"
	],
	"./HowToApply.vue": [
		"31ff",
		"chunk-446c8755"
	],
	"./Lecturers.vue": [
		"e997",
		"chunk-83bd692a"
	],
	"./Modules.vue": [
		"4228",
		"chunk-dc5ab010"
	],
	"./News.vue": [
		"a2f9",
		"chunk-4cc971b6"
	],
	"./NewsAndEvents.vue": [
		"1add",
		"chunk-5c0d84d6"
	],
	"./NewsEvents.vue": [
		"4e30",
		"chunk-122fa76a"
	],
	"./OngoingProject.vue": [
		"f23c",
		"chunk-f59bfdcc"
	],
	"./OngoingProjects.vue": [
		"7f11",
		"chunk-5b2480a6"
	],
	"./Partnership.vue": [
		"b5ac",
		"chunk-305b97a6"
	],
	"./Partnerships.vue": [
		"a02f",
		"chunk-822f755e"
	],
	"./Person.vue": [
		"ce40",
		"chunk-7ec13fdc"
	],
	"./PersonPage.vue": [
		"a19e",
		"chunk-29a54a1b"
	],
	"./Presentation.vue": [
		"8b84",
		"chunk-29c638e7"
	],
	"./PrivacyPolicy.vue": [
		"729e",
		"chunk-2d0d645d"
	],
	"./Projects.vue": [
		"acca",
		"chunk-e392b004"
	],
	"./ProjectsArchive.vue": [
		"4cac",
		"chunk-0fd6e8cf"
	],
	"./ScientificCouncil.vue": [
		"2b77",
		"chunk-a4631542"
	],
	"./SingleEvent.vue": [
		"bec6",
		"chunk-5cbb9cfd"
	],
	"./SingleEventOld.vue": [
		"2e08",
		"chunk-e71d44c8"
	],
	"./SingleModules.vue": [
		"885d",
		"chunk-2d0deec5"
	],
	"./SingleNews.vue": [
		"a022",
		"chunk-127f5463"
	],
	"./SingleStudent.vue": [
		"54c4",
		"chunk-38b8c673"
	],
	"./SingleSuccessStory.vue": [
		"3102",
		"chunk-38e7f01f"
	],
	"./Staff.vue": [
		"18d6",
		"chunk-f00bd07e"
	],
	"./Students.vue": [
		"4929",
		"chunk-5586d888"
	],
	"./SuccessStories.vue": [
		"14c3",
		"chunk-434ffd17"
	],
	"./Success_story.vue": [
		"da41",
		"chunk-78cd92a8"
	],
	"./WhoWeAre.vue": [
		"72a0",
		"chunk-3f577b28"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;